export const Language = {
    about:"About Us",
    needHelp:"Need Help",
    contact: "Contact Us",
    home:"Home",
    sample:"Samples",
    allMenuDropdown:"All",
    digitalDownload: "Digital Download",
	filterLabelYear:"By Year Level",
	filterLabelSubject:"By Subject",
	filterLabelState:"By State",
    primary:"Primary",
    secondary:"Secondary",
    filterBy:"Filter By",
    searchPlaceholder:"Search By Product name, Author, ISBN and subject",
    newUser:"Register",
    existingUser:"Login",
    viewSample:"View Sample",
    buyNow:"View Series",
    terms:"Terms & Conditions",
    privacy:"Privacy Policy",
    copyright:"Copyright © Matilda Education Australia Pty Ltd",
    noResultFound:"No Results Found",
    noResultFoundSubText:"Please try again with valid keywords",
    emptyListLabel:"No Products Available",
    filterNoBookSubText:"No product found matching the applied filter criteria",
    errorLabel:"Something went wrong",
    errorSubText:"Please try again or refresh the page again."
}


export const DigitalDownload = {
    headerText:"Enter your Access Code below to gain access to your digital resources.",
    textboxLabel:"Enter Access Code",
    verifyErrorMessage:"Sorry, we were unable to verify this code.",
    downloadLimitReachedMessage:"Sorry, the download limit for this product has been reached.",
    visitMessageLabel:"Visit: Digital Support",
    supportEmail:"Email: Customersupport@matildaeducation.com",
    supportPhoneNumber:"Phone: 1300 277 235",
    thanksForDownloadingMsg:"Thanks for downloading:",
    matildaResource:"&quot;Matilda Resources&quot;",
    downloadedFileMessage:"Files you've downloaded are automatically saved in your Downloads folder unless otherwise specified."


}